import Immutable from 'seamless-immutable';
// ---- external imports ----

import { levelSelectors } from '~/store';
import { LEVEL_UPDATE_MISSIONS } from '~/store/level/actionTypes';
// ---- internal imports ----

import customMissionHandler from './customMissionHandler';
// ---- local imports ----


function missionHandler(action) {
	return async (dispatch, getState) => {
		const missions = Immutable.asMutable(
			levelSelectors.getMissions(getState()),
			{ deep: true }
		);
		let hasMissionsChanged = false;

		if (missions === null || missions.length === 0) {
			return;
		}

		missions.forEach((mission) => {
			if (mission.completed ||
				(
					!mission.events.includes('*') &&
					!mission.events.includes(action.type)
				)
			) {
				return;
			}

			if ('customHandler' in mission) {
				const [updatedMission, missionUpdated] = customMissionHandler(
					getState(), action, mission
				);

				if (missionUpdated) {
					mission = updatedMission;
					hasMissionsChanged = true;
				}
			}
			else {
				switch (mission.type) {

					case 'positive_accumulation':
						hasMissionsChanged = true;
						mission.value += Math.max(0, action.value);
						if (mission.value >= mission.target) {
							mission.completed = true;
						}
						break;

					case 'accumulate_action_fired':
						hasMissionsChanged = true;
						mission.value++;
						if (mission.value >= mission.target) {
							mission.completed = true;
						}
						break;

					case 'action':
						hasMissionsChanged = true;
						mission.completed = true;
						break;

					default:
						console.error(`Error! Invalid mission type ${mission.type}`);
						break;
				}
			}
		});

		if (hasMissionsChanged) {
			dispatch({ type: LEVEL_UPDATE_MISSIONS, missions });
		}
	};
}


export default missionHandler;
